import { find } from 'lodash';

export const getAllInfluencerTags = state => {
  const influencerTagsDoc = find(
    state.firestore.ordered.tags,
    tags => tags.id === 'influencer'
  );
  return influencerTagsDoc ? influencerTagsDoc.interests : [];
};



// WEBPACK FOOTER //
// ./src/store/selectors/tags.js